<template>
  <v-app-bar color="primary" height="56px" app>
    <LogoWidget :height="46" />

    <v-spacer />
    <FloatSearchWidget />

    <v-app-bar-nav-icon color="white" @click="showNavigationDrawer" />
  </v-app-bar>
</template>

<script>
import FloatSearchWidget from "../../widgets/FloatSearchWidget.vue";
import LogoWidget from "../../widgets/LogoWidget.vue";

export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  methods: {
    showNavigationDrawer() {
      window.showNavigationDrawer();
    },
  },
  components: {
    LogoWidget,
    FloatSearchWidget,
  },
};
</script>
